import Link from 'next/link';
// import { Link as LinkIcon } from 'lucide-react';

const OrderMenuButton = () => {
  return (
    // <div className="h-fit rounded-lg p-px bg-[conic-gradient(from_var(--border-angle),_white,_#ea580c,_#fdba74)] transition-all duration-500 ease-out hover:animate-rotate-border flex items-center justify-center">
    <Link href="/menu" className="text-orange-600 font-medium border bg-white  px-6 py-3 rounded-lg">
      {/* <LinkIcon className="w-4 h-4 inline-block me-1" /> */}
      Add more items
    </Link>
    // </div>
  );
};

export default OrderMenuButton;
